import * as React from "react";
import classnames from "classnames";
import { motion } from "motion/react";
/* empty css                */
const transition = { ease: "easeOut", duration: 0.15 };
const variants = {
  enter: { y: 0, opacity: 1, transition },
  exit: { y: -5, opacity: 0, transition }
};
const FlyoutMenu = ({ className, ...rest }) => /* @__PURE__ */ React.createElement(
  motion.ul,
  {
    ...rest,
    role: "menu",
    className: classnames(`flyout-menu`, className),
    variants,
    initial: "exit",
    animate: "enter",
    exit: "exit"
  }
);
export {
  FlyoutMenu as default
};
//# sourceMappingURL=FlyoutMenu.js.map
